import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import DropZoneWrapper from 'components/DropZoneWrapper';
import FileUploadList from 'components/FileUploadList';

const mergeUploadedFiles = (incomingFiles, existingFiles = []) =>
    incomingFiles.reduce(
        (files, file) => {
            const exists = files.find((f) => {
                if (f.description) {
                    return file.description === f.description;
                }
                return f.name === file.name && f.size === file.size;
            });
            if (!exists) files.push(file);
            return files;
        },
        [...existingFiles],
    );

const CampaignFileList = memo(
    ({ canRemove, hidden, onChange, onRemove, value = [], withDropzone }) => {
        const handleChange = useCallback(
            (newValue = [], action = 'add') => {
                if (!onChange) return;
                const finalValue =
                    action === 'add' ? mergeUploadedFiles(newValue, value) : newValue;
                onChange(finalValue);
            },
            [onChange, value],
        );

        const renderField = useCallback(
            (isDragging = false) => (
                <FileUploadList
                    canRemove={canRemove}
                    files={value}
                    isDragging={isDragging}
                    onChange={handleChange}
                    onRemove={onRemove}
                    withAdd={true}
                    withDragZone={true}
                />
            ),
            [canRemove, handleChange, onRemove, value],
        );

        if (hidden) return null;

        if (withDropzone) {
            return (
                <DropZoneWrapper useDropzoneProps={{ onDrop: handleChange, noClick: true }}>
                    {({ isDragging }) => renderField(isDragging)}
                </DropZoneWrapper>
            );
        }

        return renderField();
    },
);

CampaignFileList.displayName = 'CampaignFileList';

CampaignFileList.propTypes = {
    canRemove: PropTypes.bool,
    hidden: PropTypes.bool,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
    value: PropTypes.array,
    withDropzone: PropTypes.bool,
};

export default CampaignFileList;
